import { createContext, useContext } from 'react';
/**
 * TODO: Add jsdoc
 */
export const SplitButtonContext = /*#__PURE__*/createContext(undefined);
export const useSplitButtonContext = () => {
  const context = useContext(SplitButtonContext);
  if (!context) {
    return undefined;
  }
  if (context.appearance === 'navigation') {
    const newContext = {
      spacing: 'default',
      appearance: 'subtle',
      isDisabled: false,
      isActiveOverSelected: false,
      isNavigationSplitButton: true,
      isHighlighted: context.isHighlighted
    };
    return newContext;
  }
  const splitButtonContext = {
    spacing: context.spacing,
    appearance: context.appearance,
    isDisabled: context.isDisabled,
    isActiveOverSelected: true,
    isNavigationSplitButton: false,
    isHighlighted: false
  };
  return splitButtonContext;
};